require('./bootstrap');

// 1. jQuery first
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

// 2. Trumbowyg JS
import 'trumbowyg/dist/trumbowyg.js';
window.Trumbowyg = $.trumbowyg; // attach to global window

// ✅ Add plugins (correct spelling)
import 'trumbowyg/plugins/base64/trumbowyg.base64';
// import 'jquery-resizable-dom';
// import 'trumbowyg/plugins/resizimg/trumbowyg.resizimg';

// 3. Trumbowyg CSS
import 'trumbowyg/dist/ui/trumbowyg.min.css';

window.Vue = require('vue').default;

import Vue from 'vue';

// register components
const requireComponent = require.context('./components', true, /\.vue$/);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName
    .split('/')
    .pop()
    .replace(/\.\w+$/, '');
  Vue.component(componentName, componentConfig.default || componentConfig);
});

import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

import VueTrumbowyg from 'vue-trumbowyg';
Vue.use(VueTrumbowyg);

import LogRocket from 'logrocket';
LogRocket.init('0wgq6l/supalytic');

import { swiffyslider } from 'swiffy-slider'
window.swiffyslider = swiffyslider;

window.addEventListener("load", () => {
  window.swiffyslider.init();
});

import "swiffy-slider/css"

import VueTimeago from 'vue-timeago'
import distanceInWordsStrict from 'date-fns/distance_in_words_strict'

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en',
  converter(date, locale, { includeSeconds, addSuffix = true }) {
    return distanceInWordsStrict(Date.now(), date, { locale, addSuffix, includeSeconds });
  }
});

import swal from 'sweetalert2';
window.Swal = swal;

import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'
Vue.use(Toaster, { timeout: 7000 });

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import linkify from 'vue-linkify'
Vue.directive('linkified', linkify)

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import moment from 'moment-timezone';

Vue.mixin({
  methods: {

    getDomain(url) {
      if (!url) return 'direct';
      try {
        url = url.trim().toLowerCase();
        url = url.replace(/^https?:\/\//, '');
        let domain = url.split('/')[0];
        domain = domain.replace(/^www\./, '');
        return domain;
      } catch (e) {
        return url;
      }
    },


    // function called domainPage which accepts a url eg: https://www.google.com/search?q=example and strips https://, http://, www. and returns google.com/search?q=example
    domainPage(url) {
      if (!url) return 'direct';
      return url
        .replace(/^https?:\/\//, '')
        .replace(/\/$/, '');
    },

    // function called getPath which accepts a url eg: https://www.google.com/search?q=example and returns the path eg: /search?q=example
    getPath(url) {
      if (!url) return null;
      try {
        const parsedUrl = new URL(url);
        let path = parsedUrl.pathname + parsedUrl.search;

        // Remove trailing slash if it's not the root "/"
        if (path.length > 1 && path.endsWith("/")) {
          path = path.slice(0, -1);
        }

        // path = null if path is just "/"
        if (path === "/") {
          path = null;
        }

        return path;
      } catch (e) {
        return null;
      }
    },

    timezoneDiff(tz) {
      // return null if no timezone provided
      if (!tz) return null;

      const now = new Date();

      // Get the offset in minutes relative to UTC
      const formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: tz,
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      // Format the same date in UTC and target timezone
      const target = formatter.formatToParts(now);
      const utc = new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).formatToParts(now);

      const getPart = (parts, type) => parseInt(parts.find(p => p.type === type).value, 10);

      const targetHour = getPart(target, "hour");
      const targetMinute = getPart(target, "minute");
      const utcHour = getPart(utc, "hour");
      const utcMinute = getPart(utc, "minute");

      // Compute total offset in minutes
      let offsetMinutes = (targetHour - utcHour) * 60 + (targetMinute - utcMinute);

      // Handle day wrap-around (e.g., -5 hours could show as 19)
      if (offsetMinutes > 720) offsetMinutes -= 1440;
      if (offsetMinutes < -720) offsetMinutes += 1440;

      const hours = Math.trunc(offsetMinutes / 60);
      const minutes = Math.abs(offsetMinutes % 60);

      const formattedOffset = `GMT ${hours >= 0 ? "+" : "-"}${String(Math.abs(hours)).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

      return `${tz} (${formattedOffset})`;
    },

    sweetfire(text) {

      Swal.fire({
        title: text,
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: true,
        focusConfirm: false,
        cancelButtonText: 'Ok',
        customClass: { title: "popup-title" },
      })

    },

    createSlug(text) {
      return text
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/&/g, '-and-')
        .replace(/[\s\W-]+/g, '-')
    },

    removeUnit(string) {
      if (string) {
        return string.replace('Unit ', '');
      } else {
        return null;
      }
    },

    formatDateSimple(date) {
      return new Date(date).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    },

    formatDateShort(date) {
      return new Date(date).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    },

    digitsAndDot(event) {
      const currentValue = event.target.value;

      // Allow backspace, delete, arrow keys, etc.
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(
          event.key
        )
      ) {
        return;
      }

      // Prevent spacebar
      if (event.key === " ") {
        event.preventDefault();
        return;
      }

      // Prevent dot (.) as the first character
      if (event.key === "." && currentValue === "") {
        event.preventDefault();
        return;
      }

      // Prevent further dots if already one exists
      if (event.key === "." && currentValue.includes(".")) {
        event.preventDefault();
        return;
      }

      // If there's already a dot, restrict input to only one digit after the dot
      const [integerPart, decimalPart] = currentValue.split(".");
      if (decimalPart && decimalPart.length >= 1 && !isNaN(Number(event.key))) {
        event.preventDefault();
        return;
      }

      // Allow only digits and one dot, prevent non-numeric input
      if (
        event.key.length === 1 &&
        isNaN(Number(event.key)) &&
        event.key !== "."
      ) {
        event.preventDefault();
      }
    },

    getAgentLogo(agent) {
      const lowerAgent = agent.toLowerCase();
      if (lowerAgent.includes('google') && lowerAgent.includes('bot')) { return 'fa-brands fa-google'; }
      else if (lowerAgent.includes('bingbot')) { return 'fa-brands fa-microsoft'; }
      else if (lowerAgent.includes('applebot')) { return 'fa-brands fa-apple'; }
      else if (lowerAgent.includes('petalsearch')) { return 'fa-sharp fa-solid fa-leaf'; }
      else if (lowerAgent.includes('facebookexternalhit')) { return 'fa-brands fa-facebook'; }
      else if (lowerAgent.includes('twitterbot')) { return 'fa-brands fa-twitter'; }
      else if (lowerAgent.includes('semrush')) { return 'fa-solid fa-plane'; }
      else if (lowerAgent.includes('ahrefs')) { return 'fa-sharp fa-solid fa-ethernet'; }
      else if (lowerAgent.includes('bot')) { return 'fa-solid fa-robot'; }
      else if (lowerAgent.includes('mobile')) { return 'fa-solid fa-mobile'; }
      else if (lowerAgent.includes('Edg')) { return 'fa-brands fa-edge'; }
      else if (lowerAgent.includes('chrome')) { return 'fa-brands fa-chrome'; }
      else if (lowerAgent.includes('safari')) { return 'fa-brands fa-safari'; }
      else if (lowerAgent.includes('opera')) { return 'fa-brands fa-opera'; }
      else if (lowerAgent.includes('firefox')) { return 'fa-brands fa-firefox'; }
      else { return 'fa-solid fa-desktop'; }
    },

    formatDescription(description) {
      return description.replace(/<br>/g, '\n');
    },

    digitsOnly(event) {
      const currentValue = event.target.value;

      // Allow backspace, delete, arrow keys, etc.
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(event.key)
      ) {
        return;
      }

      // Prevent spacebar
      if (event.key === " ") {
        event.preventDefault();
        return;
      }

      // Allow only digits, block non-digit input
      if (event.key.length === 1 && isNaN(Number(event.key))) {
        event.preventDefault();
      }
    },

    formatDateMoment(inputDate, timezone = "UTC") {
      return moment.tz(inputDate, timezone)
        .format("D MMMM YYYY HH:mm:ss");
    },

    removeDomain(url) {
      if (!url) return '/';
      try {
        const { pathname, search, hash } = new URL(url);
        return pathname + search + hash;
      } catch (e) {
        return url;
      }
    },

    timeAgo(inputDate, timezone = "UTC") {
      let result = moment.tz(inputDate, timezone).fromNow(true) + " ago";

      // replace 'a ' or 'an ' at the start of the string with '1 '
      result = result.replace(/^(a(?! few)|an) /, "1 ");

      // remove 'about ' only at the start
      result = result.replace(/^about\s+/, "");

      // replace 'a few seconds ago' with 'Just now'
      if (result === 'a few seconds ago') {
        result = 'Just now';
      }

      return result;
    },

    makeProductLink(product) {
      return `/product/${product.id}/view`;
    },

    getFlag(country) {
      return country.toLowerCase().replace(/ /g, '-') + '.svg';
    },

    formatName(name) {
      const formattedName = name.replace(/-/g, ' ');
      return formattedName.charAt(0).toUpperCase() + formattedName.slice(1);
    },

    setClass(status) {
      return status.replace(/\s+/g, '-').toLowerCase();
    },

    getWebsite(email) {
      return 'https://' + email.split('@')[1];
    },

    formatNumber(num) {
      if (num) {
        if (num >= 1000000000) {
          let formatted = (num / 1000000000).toFixed(1);
          return formatted.endsWith('.0') ? formatted.slice(0, -2) + 'B' : formatted + 'B';
        } else if (num >= 1000000) {
          let formatted = (num / 1000000).toFixed(1);
          return formatted.endsWith('.0') ? formatted.slice(0, -2) + 'M' : formatted + 'M';
        } else if (num >= 1000) {
          let formatted = (num / 1000).toFixed(1);
          return formatted.endsWith('.0') ? formatted.slice(0, -2) + 'K' : formatted + 'K';
        } else {
          return num.toString();
        }
      }
    },

    capital(str) {
      const capitalized = str.charAt(0).toUpperCase() + str.slice(1);
      return capitalized;
    },

    formattedPrice(price) {

      if (price == null) {

        return '$ 0.00';

      } else {

        // format price to 2 decimal places and append R
        return '$ ' + parseFloat(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

      }
    },

    strip_tags: function (string) {
      var string = string.replace(/(<([^>]+)>)/gi, "");
      var max_characters = 180;
      if (string.length > max_characters) {
        string = string.substring(0, max_characters);
        string = string + " ...";
      }
      return string;
    },

    truncate: function (str, maxLength = 40) {
      if (!str) return '';
      if (str.length <= maxLength) {
        return str;
      }
      return str.slice(0, maxLength) + ' >';
    },

    formatCurrency: function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    makeSlug: function (text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '')             // Trim - from end of text
        .replace(/&/g, '-and-')         // Replace & with 'and'
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    },

    niceBytes: function (x) {
      var units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        n = parseInt(x, 10) || 0,
        l = 0;
      while (n > 1024) {
        n = n / 1024;
        l++;
      }
      return (n.toFixed(n >= 10 ? 0 : 1) + ' ' + units[l]);
    },

    calculateRate(clicks, views) {
      const rate = views > 0 ? (clicks / views * 100).toFixed(1) : 0;
      return (rate == 0.0 ? 0 : rate) + '%';
    },

    document_check: function (file, type) {

      var max_size_mb = 100;    // MAXIMUM UPLOAD FILE SIZE
      var message = '';
      var valid_extensions = ['jpg', 'jpeg', 'png', 'gif'];
      var filename = file['name'];
      var extension = filename.split('.').pop().toLowerCase();
      var response = '';

      if (type == 'document') valid_extensions = ['all'];

      // check file extension
      if (type != 'document' && !valid_extensions.includes(extension)) {
        message = '<b>Invalid ' + type + '</b>\nAccepted file types are ' + valid_extensions;
        return response = { "success": false, "message": message };
      }

      // check file size
      var bytes = file.size;

      var file_size = this.niceBytes(bytes);

      var max_size_bytes = max_size_mb * 1048576;

      if (bytes > max_size_bytes) {
        message = '<b>Your ' + type + ' is ' + file_size + '</b>\nMaximum size allowed is ' + max_size_mb + ' MB';
        return response = { "success": false, "message": message };
      }

      // if everything is ok
      return response = { "success": true };

    }

  }
});

new Vue({
  el: '#app',
});

